import Icon from "../Icon/Icon";
import "./DatePickerHeader.css";

export interface DatePickerHeaderProps {
  /** the month shown (react-datepicker gives it to renderCustomHeader) */
  date: Date;
  changeYear: (year: number) => void;
  changeMonth: (month: number) => void;
  firstYear: number;
  lastYear: number;
}

const MonthYearSelect = ({
  title,
  value,
  onChange,
  options,
}: {
  title: string | number;
  value: number;
  onChange: (value: number) => void;
  options: { value: number; label: string | number }[];
}) => (
  <div className="ds-datepicker-header__item">
    <span className="ds-datepicker-header__title">{title}</span>
    <Icon name="chevronDown" size={12} />
    <select
      className="ds-datepicker-header__select"
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
    >
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  </div>
);

/**
 * Month and year pickers for the top of a react-datepicker calendar.
 * Example: renderCustomHeader={({ date, changeYear, changeMonth }) => (
 *   <DatePickerHeader date={date} changeYear={changeYear} changeMonth={changeMonth}
 *     firstYear={1900} lastYear={2026} />)}
 */
const DatePickerHeader = ({
  date,
  changeYear,
  changeMonth,
  firstYear,
  lastYear,
}: DatePickerHeaderProps) => (
  <div className="ds-datepicker-header">
    <MonthYearSelect
      title={date.toLocaleString("default", { month: "long" })}
      value={date.getMonth()}
      onChange={changeMonth}
      options={Array.from({ length: 12 }, (_, month) => ({
        value: month,
        label: new Date(0, month).toLocaleString("default", { month: "long" }),
      }))}
    />
    <MonthYearSelect
      title={date.getFullYear()}
      value={date.getFullYear()}
      onChange={changeYear}
      options={Array.from({ length: lastYear - firstYear + 1 }, (_, i) => ({
        value: firstYear + i,
        label: firstYear + i,
      }))}
    />
  </div>
);

export default DatePickerHeader;
